import { useCallback } from 'react';

import { ArrowSvg, ClearSvg } from '../wf-svg';

interface TransIconProps {
  open: boolean;
  allowClear?: boolean;
  hasSelected: boolean;
  onClear: () => void;
}

function TransIcon(props: TransIconProps) {
  const { open, allowClear, hasSelected, onClear } = props;

  const showClearIcon = allowClear && hasSelected;

  const arrowClassName = !open ? 'wf-select-arrow_fold' : 'wf-select-arrow_unfold';

  const handleClear = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onClear();
    },
    [onClear],
  );

  return (
    <>
      {showClearIcon && <ClearSvg className="wf-select-clear" onClick={handleClear} />}

      <ArrowSvg className={arrowClassName} />
    </>
  );
}

export default TransIcon;
